import { render, staticRenderFns } from "./UbSelectDivider.vue?vue&type=template&id=dd5f7200&"
import script from "./UbSelectDivider.vue?vue&type=script&lang=js&"
export * from "./UbSelectDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports